import addCopyrightLink from './modules/copyright-link.js';
import addScript from './services/script-loader.js';
import { createCmpButton } from './modules/quantcast';
import { GDPR } from './modules/quantcast/constants';
import { hideHeaderOnScroll } from './modules/sticky-header';
import { isMobile } from './services/viewport';
import { hideGlobalMask, onGlobalMaskClick, showGlobalMask } from './modules/popup-mask.js';
import { initAdScripts } from './modules/monetization/ad-scripts';
import { initFacebookPixel } from './modules/facebook-pixel';
import { initAditudeScript } from './modules/aditude';
import {
  initMenuAnalytics,
  sendMeasurement,
  EVENT_NAME,
  EVENT_LABEL,
  EVENT_TYPE,
} from './modules/analytics.js';
import { initHuman } from './modules/human.js';

document.addEventListener(`copy`, addCopyrightLink);

const AD_DELAY_TIMEOUT = 6000;

/* register service worker */
if (window.Site.oneSignalAppId) {
  addScript(`https://cdn.onesignal.com/sdks/OneSignalSDK.js`, () => {
    window.OneSignal.push([
      `init`,
      {
        appId: window.Site.oneSignalAppId,
      },
    ]);
  });
}

initHuman();

initFacebookPixel();

setTimeout(
  () => {
    initAditudeScript();
    initAdScripts();
  },
  FEATURES.AD_DELAY ? AD_DELAY_TIMEOUT : 0,
);

createCmpButton(
  document.querySelector(`#cmp-button-placeholder`),
  `c-footer__privacy-button`,
  GDPR,
  `Change privacy settings`,
);

/* temporary hard header scripts */
const $headerMenuButton = document.querySelector(`.js-header-menu-button`);
const $globalMenu = document.querySelector(`.global-menu`);
const $headerSubscribeButton = document.querySelector(`.js-header-subscribe-button`);
const $headerSubscribeContainer = document.querySelector(`.js-header-subscribe-container`);
const $header = document.querySelector(`.js-header`);

const getVh = () => window.innerHeight * 0.01;
document.documentElement.style.setProperty(`--vh`, `${getVh()}px`);

window.addEventListener(`resize`, () => {
  document.documentElement.style.setProperty(`--vh`, `${getVh()}px`);
});

function showMenu() {
  $headerMenuButton?.classList.add(`c-header-menu-button--open`);
  $globalMenu?.classList.add(`global-menu--opened`);
}

function hideMenu() {
  $headerMenuButton?.classList.remove(`c-header-menu-button--open`);
  $globalMenu?.classList.remove(`global-menu--opened`);
}

function showHeaderSubscribe() {
  if (!$headerSubscribeButton || !$headerSubscribeContainer) {
    return;
  }

  $headerSubscribeButton.classList.add(`c-header-subscribe__click-container--active`);
  $headerSubscribeContainer.classList.add(`c-header-subscribe__form-container--show`);
}

function hideHeaderSubscribe() {
  if (!$headerSubscribeButton || !$headerSubscribeContainer) {
    return;
  }

  $headerSubscribeButton.classList.remove(`c-header-subscribe__click-container--active`);
  $headerSubscribeContainer.classList.remove(`c-header-subscribe__form-container--show`);
}

if ($header && isMobile()) {
  hideHeaderOnScroll($header);
}

if ($headerMenuButton) {
  $headerMenuButton.addEventListener(`click`, () => {
    if ($headerMenuButton.classList.contains(`c-header-menu-button--open`)) {
      hideMenu();
      hideGlobalMask();
    } else {
      showMenu();
      showGlobalMask();
      hideHeaderSubscribe();
    }
  });
}

if ($headerSubscribeButton && $headerSubscribeContainer) {
  $headerSubscribeButton.addEventListener(`click`, () => {
    if ($headerSubscribeButton.classList.contains(`c-header-subscribe__click-container--active`)) {
      hideHeaderSubscribe();
      hideGlobalMask();
    } else {
      showHeaderSubscribe();
      showGlobalMask();
      hideMenu();
    }
  });
}

onGlobalMaskClick(() => {
  hideHeaderSubscribe();
  hideMenu();
});

const $sponsorBannerLink = document.querySelector(`.js-sponsor-link`);

if ($sponsorBannerLink) {
  $sponsorBannerLink.addEventListener(`click`, () => {
    window.gtag?.(`event`, `click`, {
      type: `sponsor-banner`,
    });
  });
}

if ($headerMenuButton) {
  $headerMenuButton.addEventListener(`click`, () => {
    sendMeasurement(EVENT_NAME.click, EVENT_LABEL.headerMenuButton, EVENT_TYPE.headerMenuButton);
  });
}

initMenuAnalytics();
